import Box from "@amzn/awsui-components-react/polaris/box";
import { getString } from "common/ui_string_labels/ui-strings-utils";

const getStringPath = "common.table"

const EmptyTableBox = () => {
    return (
        <Box textAlign="center" color="inherit" data-testid="empty-table">
            <b>{getString(`${getStringPath}.emptyTableTitle`)}</b>
            <Box padding={{ bottom: "s" }} variant="div" color="inherit">
                {getString(`${getStringPath}.emptyTableMessage`)}
            </Box>
        </Box>
    );
};

export default EmptyTableBox;
